import Mustache from 'mustache'

export const generatePlanCode = (planCodeSchema, { coverageTerm, insuranceLoanTerm }) => {
  const schema = planCodeSchema.join('')

  return Mustache.render(schema, {
    coverageTerm: formatToTwoDigitString(coverageTerm),
    insuranceLoanTerm: formatToTwoDigitString(insuranceLoanTerm),
  })
}

const formatToTwoDigitString = (number) => number.toString().padStart(2, '0')
